module.exports = __webpack_public_path__ + "img/2.c36d9d4e.jpg";